module.exports = __webpack_public_path__ + "static/media/icon_encrypted.541cf0f6.svg";